"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
class ColorLibController {
    constructor() {
        this.type = '';
        this.opacity = 30;
        this.metricType = '';
        this.type = 'rate';
    }
    rateCategoryLibrary() {
        return [
            {
                category: 'A++',
                categoryAlpha: 'AAA',
                title: (0, trans_1.trans)('results_view_map.legend.cats.aaa'),
            },
            {
                category: 'A+',
                categoryAlpha: 'AA',
                title: (0, trans_1.trans)('results_view_map.legend.cats.aa'),
            },
            {
                category: 'A',
                categoryAlpha: 'A',
                title: (0, trans_1.trans)('results_view_map.legend.cats.a'),
            },
            {
                category: 'B',
                categoryAlpha: 'B',
                title: (0, trans_1.trans)('results_view_map.legend.cats.b'),
            },
            {
                category: 'C',
                categoryAlpha: 'C',
                title: (0, trans_1.trans)('results_view_map.legend.cats.c'),
            },
            {
                category: 'D',
                categoryAlpha: 'D',
                title: (0, trans_1.trans)('results_view_map.legend.cats.d'),
            },
        ];
    }
    getDefaultCategory(category) {
        if (category === 'AAA')
            return 'A++';
        if (category === 'AA')
            return 'A+';
        return category;
    }
    getAlphaCategory(category) {
        if (category === 'A++')
            return 'AAA';
        if (category === 'A+')
            return 'AA';
        return category;
    }
    getCategoryTitle(category) {
        if (category) {
            const curatedCategory = this.getAlphaCategory(category);
            const allCategories = this.rateCategoryLibrary();
            const currCat = allCategories.find((cat) => (cat === null || cat === void 0 ? void 0 : cat.categoryAlpha) === curatedCategory);
            return currCat === null || currCat === void 0 ? void 0 : currCat.title;
        }
        else {
            return '';
        }
    }
    getCategoryFromScore(score) {
        // TODO: Add a method to know which category belong a rate score
        if (score >= 0 && score < 50)
            return 'D';
        if (score >= 50 && score < 60)
            return 'C';
        if (score >= 60 && score < 70)
            return 'B';
        if (score >= 70 && score < 80)
            return 'A';
        if (score >= 80 && score < 90)
            return 'AA';
        if (score >= 90 && score <= 100)
            return 'AAA';
        return 'A';
    }
    getCategoryColor(v) {
        let color = '#000000';
        if (v !== undefined) {
            switch (v.toLowerCase()) {
                case 'aaa':
                    color = '#67bf3e';
                    break;
                case 'a++':
                    color = '#67bf3e';
                    break;
                case 'aa':
                    color = '#a1e681';
                    break;
                case 'a+':
                    color = '#a1e681';
                    break;
                case 'a':
                    color = '#e6d581';
                    break;
                case 'b':
                    color = '#efcf32';
                    break;
                case 'c':
                    color = '#ff9a51';
                    break;
                case 'd':
                    color = '#e47c79';
                    break;
                default:
                    color = '#282b25';
            }
        }
        else {
            color = '#282b25';
        }
        return color;
    }
    getDiseasesColor(v) {
        let color = '#787573';
        switch (v.toLowerCase()) {
            case '0':
                color = '#787573';
                break;
            case '1':
                color = '#e6d581';
                break;
            case '2':
                color = '#efcf32';
                break;
            case '3':
                color = '#ff9a51';
                break;
            case '4':
                color = '#e47c79';
                break;
            case '5':
                color = '#e52721';
                break;
            default:
                color = '#787573';
        }
        return color;
    }
    getCategoryColor_3(v) {
        let color = '#000000';
        switch (v.toLowerCase()) {
            case 'a++':
                color = '#294c19';
                break;
            case 'a+':
                color = '#405c34';
                break;
            case 'a':
                color = '#5c5534';
                break;
            case 'b':
                color = '#605314';
                break;
            case 'c':
                color = '#663e20';
                break;
            case 'd':
                color = '#5b3230';
                break;
            default:
                color = '#282b25';
        }
        return color;
    }
    getCategoryColor_2(v) {
        let color = '#000000';
        switch (v.toLowerCase()) {
            case 'a++':
                color = '#3e7325';
                break;
            case 'a+':
                color = '#618a4d';
                break;
            case 'a':
                color = '#8a804d';
                break;
            case 'b':
                color = '#8f7c1e';
                break;
            case 'c':
                color = '#995c31';
                break;
            case 'd':
                color = '#894a49';
                break;
            default:
                color = '#282b25';
        }
        return color;
    }
    getCategoryColor_1(v) {
        let color = '#000000';
        switch (v.toLowerCase()) {
            case 'a++':
                color = '#529932';
                break;
            case 'a+':
                color = '#81b867';
                break;
            case 'a':
                color = '#b8aa67';
                break;
            case 'b':
                color = '#bfa628';
                break;
            case 'c':
                color = '#cc7b41';
                break;
            case 'd':
                color = '#b66361';
                break;
            default:
                color = '#282b25';
        }
        return color;
    }
    getRankColor(v) {
        let color = '#787573';
        switch (v) {
            case '0':
                color = '#787573';
                break;
            case '1':
                color = '#f6cb2c';
                break;
            case '2':
                color = '#e6c25c';
                break;
            case '3':
                color = '#c8d6e4';
                break;
            case '4':
                color = '#85c5f5';
                break;
            case '5':
                color = '#1887e4';
                break;
            default:
                color = '#787573';
        }
        return color;
    }
    getCategoryTransparency(v) {
        const color = this.getCategoryColor(v);
        return color + this.opacity;
    }
    getRankTransparency(v, typeD) {
        let color;
        if ((this.type === 'diseases' || typeD === 'diseases')
        // && this.metricType === 'HLT'
        ) {
            color = this.getDiseasesColor(v);
        }
        else {
            color = this.getRankColor(v);
        }
        return color + this.opacity;
    }
    getColor(v, typeD) {
        if (this.type === 'rate' || this.type === 'cert') {
            return this.getCategoryColor(v);
        }
        else if ((this.type === 'diseases' || typeD === 'diseases')
        //&& this.metricType === 'HLT'
        ) {
            return this.getDiseasesColor(v);
        }
        else {
            return this.getRankColor(v);
        }
    }
    getColorWithScale(v, scale) {
        if (scale === 'cert')
            return this.getCategoryColor(v);
        if (scale === 'need' || scale === 'hlt')
            return this.getDiseasesColor(v);
        return this.getRankColor(v);
    }
    getTransparency(v, typeD) {
        if (this.type === 'rate') {
            return this.getCategoryTransparency(v);
        }
        else {
            return this.getRankTransparency(v, typeD);
        }
    }
    getCSSClassesForCategory(category) {
        const curatedCategory = this.getAlphaCategory(category);
        return ('bmfw-background-color-bmk_certificate_' +
            curatedCategory.toLowerCase() +
            ' bmfw-color-bmk_certificate_' +
            curatedCategory.toLowerCase() +
            '_darkest');
    }
    getRankFromNeedScore(s) {
        if (s > 0) {
            if (s <= 39) {
                return 1;
            }
            else {
                if (s <= 59) {
                    return 3;
                }
                else {
                    return 5;
                }
            }
        }
        else {
            return -1;
        }
    }
    getRankFromScore(s) {
        if (s >= 0) {
            if (s <= 19) {
                // 0 - 20
                if (s === 0)
                    return 0;
                return 1;
            }
            else {
                if (s <= 39) {
                    // 21 - 40
                    return 2;
                }
                else {
                    if (s <= 59) {
                        // 41 - 60
                        return 3;
                    }
                    else {
                        if (s <= 79) {
                            // 61 - 80
                            return 4;
                        }
                        else {
                            // 81 - 100
                            return 5;
                        }
                    }
                }
            }
        }
        else {
            return -1;
        }
    }
    getRankShortNameFromNumber(rank) {
        switch (rank) {
            case 1:
                return 'vl';
            case 2:
                return 'l';
            case 3:
                return 'm';
            case 4:
                return 'h';
            case 5:
                return 'vh';
            default:
                return 'nd';
        }
    }
    getRankShortNameFromScore(s) {
        return this.getRankShortNameFromNumber(this.getRankFromScore(s));
    }
    getRankShortNameFromNeedScore(s) {
        return this.getRankShortNameFromNumber(this.getRankFromNeedScore(s));
    }
    getRankLabel(rank) {
        return (0, trans_1.trans)('dashboard.insiders.lvls.' + this.getRankShortNameFromNumber(rank));
    }
    darkenColor(hexColor, factor) {
        hexColor = hexColor.replace('#', '');
        // Convertir el color hexadecimal a valores RGB
        let r = parseInt(hexColor.substring(0, 2), 16);
        let g = parseInt(hexColor.substring(2, 4), 16);
        let b = parseInt(hexColor.substring(4, 6), 16);
        // Aplicar el factor de oscuridad
        r = Math.max(0, Math.min(255, Math.floor(r * factor)));
        g = Math.max(0, Math.min(255, Math.floor(g * factor)));
        b = Math.max(0, Math.min(255, Math.floor(b * factor)));
        // Convertir los valores RGB de vuelta a hexadecimal
        const darkenedHexColor = '#' +
            r.toString(16).padStart(2, '0') +
            g.toString(16).padStart(2, '0') +
            b.toString(16).padStart(2, '0');
        return darkenedHexColor;
    }
}
exports.default = ColorLibController;
